export default "__VITE_ASSET__B8iNPe$0__"